define.alias("shared/utils/string-formatters/snake-to-camel", "preview-grid/utils/string-formatters/snake-to-camel");